import { render, staticRenderFns } from "./EditActivityForm.vue?vue&type=template&id=4c2c4797&scoped=true"
import script from "./EditActivityForm.vue?vue&type=script&lang=ts"
export * from "./EditActivityForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2c4797",
  null
  
)

export default component.exports